import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonStyle } from '@constants/button/1.0';
import { MessageType } from '@constants/message/1.0';
import { ButtonComponent } from '../../button/1.0/button.component';

@Component({
  selector: 'txp-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  standalone: true,
  imports: [ButtonComponent],
})

/**
 * Displays a message banner to the user. Intended for page-level error, warning, success, and info messages.
 */
export class MessageComponent {
  @Input() type: MessageType;
  @Input() style: ButtonStyle;
  @Input() dismissible: boolean;
  @Output() dismiss: EventEmitter<any> = new EventEmitter<any>();

  buttonStyle = ButtonStyle.ALERT;
}
